<template>
    <div >
        <ul class="nav nav-tabs">
            <li class="active">
                <a data-toggle="tab"  title="Marié ou partenariat enregistré"> {{$t('Bareme.etape1.champs.sectionMarie')}}</a></li>
        </ul>
        <div class="row">

            <div class="col-md-6">
                <!--Votre conjoint perçoit un revenu en Suisse ou l’étranger ?-->
                <div class="form-group required" :class="{'has-error': errors.has('hasConjointRevenu')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.conjointPercoitRevenu')}}</label>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.conjointPercoitRevenu','Bareme.tooltip.contenu.conjointPercoitRevenu'),
                               trigger: 'hover', placement: tooltipPlacement }">
                            <input type="radio" v-bind:value="true" name="hasConjointRevenu"
                                   v-model="dossier.hasConjointRevenu" v-validate="'required'" :aria-label="$t('general.oui')">
                            {{$t('general.oui')}}
                        </label>
                    </div>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.conjointPercoitRevenu','Bareme.tooltip.contenu.conjointPercoitRevenu'),
                               trigger: 'hover', placement: tooltipPlacement }">
                            <input type="radio" v-bind:value="false" name="hasConjointRevenu"
                                   v-model="dossier.hasConjointRevenu" :aria-label="$t('general.non')">
                            {{$t('general.non')}}
                        </label>
                    </div>
                    <span v-if="submitted && errors.has('hasConjointRevenu')" class="text-danger">{{ errors.first('hasConjointRevenu')}}</span>
                </div>
            </div>

            <div class="col-md-6">

                <div v-if="dossier.hasConjointRevenu" class="form-group required" :class="{'has-error': errors.has('sourceRevenu')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.siRevenuConjoint')}} </label>
                    <div class="checkbox" v-for="sr in listeReference.sourceRevenu" v-bind:key="sr.value">
                        <label v-tooltip="{content: getTooltip('Bareme.tooltip.titre.siConjointPercoitRevenu','Bareme.tooltip.contenu.siConjointPercoitRevenu'),
                        trigger: 'hover', placement: tooltipPlacement }">
                            <input type="checkbox" class="checkbox"
                                      name="sourceRevenu"  v-validate="'required'"
                                      v-model="dossier.sourceRevenu" :id="sr.value"
                                      :value="{value: sr.value, description: sr.description, label: sr.label, code:sr.code}">{{sr.description}}</label>
                    </div>
                    <span v-if="submitted && errors.has('sourceRevenu')" class="text-danger">{{ errors.first('sourceRevenu')}}</span>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-6">

                <!--Votre conjoint est-il fonctionnaire international ?-->
                <div v-if="dossier.hasConjointRevenu" class="form-group required" :class="{'has-error': errors.has('isConjointFonctionnaireInt')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.conjointFonctionnaireInternational')}}</label>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltipAvecOptions('Bareme.tooltip.titre.fonctionnaireInt','Bareme.tooltip.contenu.fonctionnaireInt', null,
                         {url: 'https://www.ge.ch/lc/iso-0'}),
                        trigger: 'hover', placement: tooltipPlacement }">
                            <input type="radio" v-bind:value="true" name="isConjointFonctionnaireInt" v-validate="'required'"
                                      v-model="dossier.isConjointFonctionnaireInt" :aria-label="$t('general.oui')">{{$t('general.oui')}}</label>
                    </div>
                    <div class="radio">
                        <label v-tooltip="{content: getTooltipAvecOptions('Bareme.tooltip.titre.fonctionnaireInt','Bareme.tooltip.contenu.fonctionnaireInt', null,
                         {url: 'https://www.ge.ch/lc/iso-0'}),
                        trigger: 'hover', placement: tooltipPlacement }">
                            <input type="radio" v-bind:value="false" name="isConjointFonctionnaireInt"
                                      v-model="dossier.isConjointFonctionnaireInt" :aria-label="$t('general.non')">{{$t('general.non')}}</label>
                    </div>
                    <span v-if="submitted && errors.has('isConjointFonctionnaireInt')" class="text-danger">{{ errors.first('isConjointFonctionnaireInt')}}</span>
                </div>

            </div>
            <div class="col-md-6">
                <div v-if="dossier.isConjointFonctionnaireInt && dossier.hasConjointRevenu" class="form-group required" :class="{'has-error': errors.has('typeFonctInt')}">
                    <label class="form-label">{{$t('Bareme.etape1.champs.typeFonctionnaireInternational')}}</label>
                    <div class="radio" v-for="tp in listeReference.bareme" v-bind:key="tp.value">
                        <label  v-tooltip="{content: getTooltipAvecOptions('Bareme.tooltip.titre.typeFonctionnaireInt','Bareme.tooltip.contenu.typeFonctionnaireInt', null,
                         {urlB: 'https://www.ge.ch/c/imp-orgbab', urlC: 'https://www.ge.ch/c/imp-orgbac'}),
                        trigger: 'hover', placement: tooltipPlacement }">
                            <input type="radio" name="typeFonctInt" v-model="dossier.typeFonctInt" v-validate="'required'"
                                       :value="{value: tp.value, description: tp.description}" :aria-label="tp.description">{{tp.description}}</label>
                    </div>
                    <span v-if="submitted && errors.has('typeFonctInt')" class="text-danger">{{ errors.first('typeFonctInt')}}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import TooltipUtils from '../../../utils/TooltipUtils';

export default {
  name: 'section-marie',
  props: ['dossier', 'submitted', 'listeReference'],
  inject: ['$validator'],
  mixins: [TooltipUtils],
  data() {
    return {
      listeSourceRevenu: [],
    };
  },
};
</script>

<style scoped>

</style>
